import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { isNil } from 'lodash';

export function getPasswordValidation(context: any): ValidatorFn | null {
  return Validators.compose([
    Validators.required,
    Validators.minLength(8),
    uppercaseValidator,
    lowercaseValidator,
    numericValidator,
    specialCharacterValidator,
    validateFNameNotInPassword.bind(context),
    validateLNameNotInPassword.bind(context),
  ]);
}

export function matchValidator(control: AbstractControl) {
  const newPassword = control.get('newPassword');
  const confirmPassword = control.get('confirmPassword');

  if (newPassword?.value !== confirmPassword?.value) {
    return { mismatch: true };
  }

  return null;
}

function uppercaseValidator(control: AbstractControl) {
  const regex = new RegExp('(?=.*[A-Z])');

  if (regex.test(control.value)) {
    return null;
  }

  return { uppercase: true };
}

function specialCharacterValidator(control: AbstractControl) {
  const regex = new RegExp('^[^<>äöüÄÖÜßæ]+$');

  if (regex.test(control.value)) {
    return null;
  }

  return { specialcharacter: true };
}

function lowercaseValidator(control: AbstractControl) {
  const regex = new RegExp('(?=.*[a-z])');

  if (regex.test(control.value)) {
    return null;
  }

  return { lowercase: true };
}

function numericValidator(control: AbstractControl) {
  const regex = new RegExp('(?=.*[0-9])');

  if (regex.test(control.value)) {
    return null;
  }

  return { numeric: true };
}

function validateFNameNotInPassword(this: any, control: FormControl) {
  if (isNil(control.value) || control.value.length === 0) {
    return null;
  }

  if (!isNil(this.firstName) && this.firstName.length > 0) {
    if (control.value.toLowerCase().includes(this.firstName.toLowerCase())) {
      return { fnameNotInPassword: true };
    }
    return null;
  }
  return null;
}

function validateLNameNotInPassword(this: any, control: FormControl) {
  if (isNil(control.value) || control.value.length === 0) {
    return null;
  }

  if (!isNil(this.lastName) && this.lastName.length > 0) {
    if (control.value.toLowerCase().includes(this.lastName.toLowerCase())) {
      return { lnameNotInPassword: true };
    }
    return null;
  }
  return null;
}
